export default __webpack_public_path__ + "cb09436a797b5964e9d17b000f58c21d.png";